import * as api from 'services/api';
import { addError } from 'actions/error';

export const getLayout = (category, name, suppressErrors = false) => (dispatch) => {
  if (suppressErrors) {
    // When suppressing errors, wrap the API call in a promise that always resolves
    // This prevents any unhandled rejections. Pass suppressErrors to API layer too
    // so createRequest short-circuits instead of throwing on network issues.
    return new Promise((resolve) => {
      // Create the API promise and immediately attach handlers
      const apiPromise = api.get(`layouts/${category}/${name}`, 'GET_LAYOUT', dispatch, undefined, {
        suppressErrors: true
      });
      
      // Attach handlers synchronously before the promise can reject
      apiPromise
        .then((result) => {
          // Success case - resolve with result
          resolve(result);
        })
        .catch((error) => {
          // Error case - silently handle and resolve with null instead of rejecting
          // This ensures the promise always resolves, preventing unhandled rejections
          // Only log if it's not a network error (those are expected when API is down)
          const errorMessage = error?.message || error?.toString() || '';
          const isNetworkError = errorMessage.includes('Failed to fetch') || 
                                errorMessage.includes('CORS') ||
                                errorMessage.includes('NetworkError');
          
          if (!isNetworkError) {
            console.warn(`getLayout(${category}/${name}) failed:`, errorMessage);
          }
          
          // Always resolve with null to prevent unhandled rejections
          resolve(null);
        });
    });
  }
  
  // Normal error handling - dispatch error notification
  const apiPromise = api.get(`layouts/${category}/${name}`, 'GET_LAYOUT', dispatch);
  return apiPromise.catch((error) => {
    dispatch(addError(new Error('GET_LAYOUT_INFO_ERROR')));
    throw error; // Re-throw so components can catch it
  });
};
